import { createContext } from 'react';

export const ThemeContext = createContext({
  size: '', // small normal
});

export const SIZES = {
  small: 'small',
  middle: 'middle',
  large: 'large',
};

const SIZE_BREAKPOINTS = {
  [SIZES.small]: 480,
  [SIZES.middle]: 960,
  [SIZES.large]: 99999,
};

export const getSize = (width) => {
  for (let size of ['small', 'middle', 'large']) {
    if (width < SIZE_BREAKPOINTS[size]) {
      return size;
    }
  }
};
